import { render, staticRenderFns } from "./DTSEdit.vue?vue&type=template&id=ecde7612&"
import script from "./DTSEdit.vue?vue&type=script&lang=js&"
export * from "./DTSEdit.vue?vue&type=script&lang=js&"
import style0 from "./DTSEdit.vue?vue&type=style&index=0&id=ecde7612&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports